<template>
	<div id="calc" class="calculator wrapper container-fluid" @click.stop.prevent="handleClick">
		<p class="txt--xl mb--2 mb-2">
			A simple questionnaire to measure the adequacy of asthma control and change in asthma control - either spontaneously or as a result of treatment.
		</p>
		
		<div class="tabs mb--2">
			<nav class="tabs__nav">
				<button v-for="(tab) in tabs" v-bind:key="tab.title" role="button" class="tabs__nav-item txt--strong" :class="{ 'tabs__nav-item--active bg--primary': tab.display }" v-on:click="selectTab(tab)">
					<span v-html="tab.title"></span>
					<i v-if="!tab.display" aria-hidden="true" class="fa fa-chevron-down ml-1 ml--1 show--md"></i>
					<i v-if="tab.display" aria-hidden="true" class="fa fa-chevron-up ml-1 ml--1 show--md"></i>	
				</button>
			</nav>
			<div class="tabs__content" id="tabcontent">
				<div v-for="(tab) in tabs" v-bind:key="tab.content"> 
					<div v-if="tab.display" class="bdr--light-gray p--1 wysiwyg" :aria-labelledby="tab.title" role="tabpanel" v-html="tab.content"></div>
				</div>
			</div>
		</div>

		<!-- <div class="accordion bdr--light-gray accordion--arrows mb--2 hide--md">
			<div class="accordion__item bdr__top--light-gray" data-accordion-type="default" v-for="(tab, index) in tabs" v-bind:key="tab.title">
				<button :id="'tab'+index" class="accordion__header txt--md txt--strong" :class="{ 'accordion__header--active' : tab.accordion }" @click="tab.accordion = !tab.accordion">{{tab.title}}</button>
				<div :aria-labelledby="'tab'+index" class="accordion__content" :class="{ 'accordion__content--active active' : tab.accordion }" v-html="tab.content"></div>
			</div>
		</div> -->

		<!-- <p>Click on the answer to each question below, then click on Calculate.</p> -->

		<div id="error" class="row">
			<div class="col-12 col-sm-12">
				<div class="alert alert-danger alert--error mb-3 mb--3" role="alert" v-if="errormessage.length > 0">{{errormessage}}</div>
			</div>
		</div>
		<div class="row" v-if="current_page == 1 && !displayresult">
			<div class="col-12 col-sm-12 mb-1 mb--1">
				<h2>
					Asthma Control Questionnaire(ACQ)<br />
					<span class="txt--sm">(symptoms only - ACQ 5)</span>
				</h2>

				<p><strong>English version for the United Kingdom</strong></p>
        <p>This tool includes 5 questions. One question is presented per page. This format is a requirement set by the copyright owner.</p>
				<p>&#169; The Asthma Control Questionnaire (ACQ) is copyrighted and all rights are reserved. No part of this questionnaire may be sold, modified or reproduced in any form without the express permission of Elizabeth Juniper on behalf of QOL Technologies Limited.</p>
			</div>
		</div>
		<div class="row" v-if="current_page == 2 && !displayresult">
			<div class="col-12 col-sm-12 mb-1 mb--1">
				<p>Please answer questions 1-5. </p>
				<p><strong>Select</strong> the response that best describes how you have been during the past week.</p>
			</div>
		</div>
		<div class="row" v-if="current_page > 2 && !displayresult">
			<div class="col-12 col-sm-12 mb-1 mb--1">
				<div class="row">
					<div class="col-12 col-xs-12 col-sm-6">
						<h3>{{current_question.title}}</h3>
						<div v-html="current_question.info"></div>
					</div>
					<div class="col-12 col-xs-12 col-sm-6">
						<div class="list-group">
							<div v-for="o in current_question.options" :key="o.id">
								<button @click="optionclicked(current_question.id,o.id)"
										@keydown.enter="optionclicked(event, current_question.id,o.id)"
										type="button"
										v-bind:class="{'list-group-item list-group-item-action d-flex justify-content-between align-items-center active':(o.selected), 'list-group-item list-group-item-action d-flex justify-content-between align-items-center':(!o.selected)}">
									{{o.text}}
									<span class="badge badge-success badge-pill">{{o.value_label}}</span>
								</button>
							</div>
						</div>
					</div>
					<div class="col-12 col-xs-12">
						<p class="mt--2">For any information on the use of the electronic ACQ, please contact Mapi Research Trust, Lyon, France</p>
						<p>Internet: <a href="https://eprovide.mapi-trust.org" target="_blank">https://eprovide.mapi-trust.org</a></p>
					</div>
				</div>
				<hr class="mb-2 mb--2">
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-sm-12">
				<div class="bg-secondary bg--secondary p--2 p-2 mb--2 mb-2">
					<div id="calculator-copy" class="color--white text-white mb-1 mb--1" v-if="displayresult">
						<div id="result-response" v-if="isvalid"></div>
						<p class="h3 txt--xl"><strong>Recommendation:</strong> {{result.text}}</p>
						<h3 class="h4 txt--lg"><strong>Total ACQ5 score</strong> : {{result.score}}</h3>
						<p v-html="result.subtext"></p>
						<p v-html="result.calctext"></p>
					</div>
					<div class="control-holder">
						<button class="btn mr-1 mr--1" @click="pageBack" v-if="current_page > 1 && !displayresult">Previous</button>
						<button class="btn mr-1 mr--1 btn-secondary" @click="pageForward" v-if="current_page < 7 && !displayresult">Next</button>
						<button class="btn mr-1 mr--1" @click="calculateclicked" type="button" v-if="!displayresult && current_page > 6">Calculate</button>
						<button class="btn mr-1 mr--1 btn-secondary" type="button" @click="reset" v-if="displayresult">Reset</button>
            <button class="btn mr-1 mr--1" id="copyButton" type="button" @click="copyToClipboard" v-if="displayresult">Copy Result</button>
						<button class="btn mr-1 mr--1 hide--quris" type="button" @click="displayForm" v-if="displayresult">Email PDF</button>
					</div>
				</div>
				<div class="bg--offwhite bg-offwhite p-2 p--2" v-if="displayresult && showform">
						<p class="color--black">For security reasons, this form is only available within the NHS network. You can use it to email to an NHS email a PDF with the decision support result for this patient and then save it to the patient record.</p>
						<div class="color--black alert alert-danger alert--error mb-1 mb--1" role="alert" v-if="emailmessage.length > 0" v-html="emailmessage"></div>
						<div class="form__group mb--2">
							<label for="emailaddresses" class="form__label mb--1 txt--strong">Email addresses:</label>
							<input v-model="emailaddresses" type="text" class="form__input" name="emailaddresses" id="emailaddresses" placeholder="Enter email address(es) to receive this decision support output. NHS emails only">
						</div>
						<div class="form__group mb--2">
							<label for="patientname" class="form__label mb--1 txt--strong">Patient's Full Name:</label>
							<input v-model="patientname" type="text" class="form__input" name="patientname" id="patientname" placeholder="Enter patient’s full name">
						</div>
						<div class="form__group mb--2">
							<label for="patientchinumber" class="form__label mb--1 txt--strong">Patient CHI Number:</label>
							<input v-model="patientchinumber" type="text" class="form__input" name="patientchinumber" id="patientchinumber" placeholder="Enter patient’s CHI number">
						</div>
						<button class="btn mr-1 mr--1" type="button" @click="sendToPDF">Send</button>
					</div>
					<div class="alert alert-success alert--success mb-3 mb--3" role="alert" v-if="displayresult && !showform && emailmessage.length > 0 && emailaddresses.length > 0 && patientname.length > 0 && patientchinumber.length > 0" v-html="emailmessage"></div>
			</div>
		</div>
		<Content />
	</div>
</template>

<script>
import Content from "@/components/Content.vue";
import "isomorphic-fetch";

export default {
  name: "Calculator",
  components: {
		Content
  },
  data() {
    return {
      emailaddresses: "",
      patientname: "",
      patientchinumber: "",
      questions: [
        {
          id: "q1",
          title: "1. Times woken",
          required: false,
          info: "<p>On average, during the past week, how often were you woken by your asthma during the night?</p>",
          options: [
            {
              id: "o1",
              text: "Never",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o2",
              text: "Hardly ever",
              value_label: "+1",
              value: 1,
              selected: false
            },
            {
              id: "o3",
              text: "A few times",
              value_label: "+2",
              value: 2,
              selected: false
            },
            {
              id: "o4",
              text: "Several times ",
              value_label: "+3",
              value: 3,
              selected: false
            },
            {
              id: "o5",
              text: "Many times ",
              value_label: "+4",
              value: 4,
              selected: false
            },
            {
              id: "o6",
              text: "A great many times ",
              value_label: "+5",
              value: 5,
              selected: false
            },
            {
              id: "o7",
              text: "Unable to sleep because of asthma.",
              value_label: "+6",
              value: 6,
              selected: false
            }
          ]
        },
        {
          id: "q2",
          title: "2. Morning symptoms",
          required: true,
          info: "<p>On average, during the past week, how bad were your asthma symptoms when you woke up in the morning?</p>",
          options: [
            {
              id: "o8",
              text: "No symptoms ",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o9",
              text: "Very mild symptoms",
              value_label: "+1",
              value: 1,
              selected: false
            },
            {
              id: "o10",
              text: "Mild symptoms",
              value_label: "+2",
              value: 2,
              selected: false
            },
            {
              id: "o11",
              text: "Moderate symptoms",
              value_label: "+3",
              value: 3,
              selected: false
            },
            {
              id: "o12",
              text: "Quite severe symptoms",
              value_label: "+4",
              value: 4,
              selected: false
            },
            {
              id: "o13",
              text: "Severe symptoms",
              value_label: "+5",
              value: 5,
              selected: false
            },
            {
              id: "o14",
              text: "Very severe symptoms",
              value_label: "+6",
              value: 6,
              selected: false
            }
          ]
        },
        {
          id: "q3",
          title: "3. Activity limitation",
          required: true,
          info: "<p>In general, during the past week, how limited were you in your activities because of your asthma?</p>",
          options: [
            {
              id: "o15",
              text: "Not limited at all" ,
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o16",
              text: "Very slightly limited ",
              value_label: "+1",
              value: 1,
              selected: false
            },
            {
              id: "o17",
              text: "Slightly limited",
              value_label: "+2",
              value: 2,
              selected: false
            },
            {
              id: "o18",
              text: "Moderately limited",
              value_label: "+3",
              value: 3,
              selected: false
            },
            {
              id: "o19",
              text: "Very limited ",
              value_label: "+4",
              value: 4,
              selected: false
            },
            {
              id: "o20",
              text: "Extremely limited ",
              value_label: "+5",
              value: 5,
              selected: false
            },
            {
              id: "o21",
              text: "Totally limited",
              value_label: "+6",
              value: 6,
              selected: false
            }
          ]
        },
        {
          id: "q4",
          title: "4. Shortness of breath",
          required: true,
          info: "<p>In general, during the past week, how much shortness of breath did you experience because of your asthma?</p>",
          options: [
            {
              id: "o22",
              text: "None",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o23",
              text: "A very little",
              value_label: "+1",
              value: 1,
              selected: false
            },
            {
              id: "o24",
              text: "A little",
              value_label: "+2",
              value: 2,
              selected: false
            },
            {
              id: "o25",
              text: "A moderate amount",
              value_label: "+3",
              value: 3,
              selected: false
            },
            {
              id: "o26",
              text: "Quite a lot",
              value_label: "+4",
              value: 4,
              selected: false
            },
            {
              id: "o27",
              text: "A great deal",
              value_label: "+5",
              value: 5,
              selected: false
            },
            {
              id: "o28",
              text: "A very great deal",
              value_label: "+6",
              value: 6,
              selected: false
            }
          ]
        },
        {
          id: "q5",
          title: "5. Wheeze",
          required: true,
          info: "<p>In general, during the past week, how much of the time did you wheeze?</p>",
          options: [
            {
              id: "o29",
              text: "Not at all ",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o30",
              text: "Hardly any of the time ",
              value_label: "+1",
              value: 1,
              selected: false
            },
            {
              id: "o31",
              text: "A little of the time ",
              value_label: "+2",
              value: 2,
              selected: false
            },
            {
              id: "o32",
              text: "A moderate amount of the time ",
              value_label: "+3",
              value: 3,
              selected: false
            },
            {
              id: "o33",
              text: "A lot of the time ",
              value_label: "+4",
              value: 4,
              selected: false
            },
            {
              id: "o34",
              text: "Most of the time ",
              value_label: "+5",
              value: 5,
              selected: false
            },
            {
              id: "o35",
              text: "All the time",
              value_label: "+6",
              value: 6,
              selected: false
            }
          ]
        }
      ],
      result: {
        score: 0,
        calctext: "",
        text: "",
        subtext: ""
      },
      displayresult: false,
      showform: false,
      errormessage: "",
      emailmessage: "",
      isvalid: false,
			answered_count: 0,
			current_q_index: 0,
			answer_acutechange: false,
			answered_question: false,
      current_page: 1,
			current_question: null,
			tabs: [
        {
          title: "When to use",
          display: false,
          accordion: false,
					content: `
						<p>International guidelines for the treatment of asthma identify that the primary clinical goal of asthma management is to optimise control – i.e. minimisation of:  symptoms, limitation of activity, bronchoconstriction and use of rescue Beta-2 agonists. Optimisation of control will reduce the risk of life-threatening exacerbations and long-term morbidity.</p>
						<p>The Asthma Control Questionnaire was developed to meet these criteria. It measures the adequacy of asthma control and change in asthma control, which occurs either spontaneously or as a result of treatment.</p>
						<p>The ACQ is well validated in adults and for all children 6-17 years. The self-administered version can be used by children 11 years and older. For children of 6-10 years, the questionnaire should be administered by a trained interviewer.  The ACQ has not been validated for children younger than 6 years old.</p>
						<p>The ACQ 5 is the validated 5-question version of the full 7-question ACQ. The ACQ5 does not require clinician measurement of FEV, so is more suited to remote consultation.</p>
					`,
        },
        {
          title: "Evidence",
          display: false,
          accordion: false,
					content: `
						<h4 class="txt--xl">Key references:</h4>
						<p><strong>Juniper EF, O'Byrne PM, Guyatt GH, Ferrie PJ, King DR. Development and validation of a questionnaire to measure asthma control. <em>Eur Respir J</em>. 1999;14(4):902-907. <a href="https://pubmed.ncbi.nlm.nih.gov/10573240/" target="_blank">doi:10.1034/j.1399-3003.1999.14d29.x</a></strong></p>
						<ul><li>This original study tested the 7-question version of the ACQ in a 9-week observational study of 50 adults with symptomatic asthma. In patients whose asthma was stable between clinic visits, reliability of the ACQ was high. The questionnaire was very responsive to change in asthma control (p<0.0001). Cross-sectional and longitudinal validity were supported by correlations between the ACQ and other measures of asthma health status. The authors concluded that the Asthma Control Questionnaire has strong evaluative and discriminative properties and can be used with confidence to measure asthma control.</li></ul>
						<p><strong>Juniper EF, Bousquet J, Abetz L, Bateman ED; GOAL Committee. Identifying 'well-controlled' and 'not well-controlled' asthma using the Asthma Control Questionnaire. <em>Respir Med</em>. 2006;100(4):616-621. <a href="https://pubmed.ncbi.nlm.nih.gov/16226443/" target="_blank">doi:10.1016/j.rmed.2005.08.012</a></strong></p>
						<ul><li>This analysis aimed to determine the cut-off point on the ACQ that best differentiates between 'well-controlled' and 'not well-controlled.' The study concluded that to be confident that the patient has inadequately controlled asthma, the optimal cut-off point is 1.50 (positive predictive value=0.88). Knowledge of these cut-points  should enhance practising clinicians' ability to identify patients whose asthma requires additional treatment.</li></ul>
						<p><strong>Juniper EF, Gruffydd-Jones K, Ward S, Svensson K. Validation, measurement properties and interpretation of the Asthma Control Questionnaire in children. <em>Eur Respir J</em> 2010: 36: 1410-1416. <a href="https://erj.ersjournals.com/content/36/6/1410" target="_blank">DOI: 10.1183/09031936.00117509</a></strong></p>
						<ul>
							<li>This study evaluated the validity, measurement properties and interpretability of the ACQ in children aged 6–16 yrs.</li>
							<li>35 children attended clinic on three occasions (0, 1 and 4 weeks) and completed the ACQ and multiple comparator questionnaires. The study concluded that the ACQ has strong measurement properties and is valid for use in children aged 6–16 yrs. In children aged 6–10 yrs, it must be administered by a trained interviewer.</li>
						</ul>
						<p><strong>Juniper EF, Svensson K, Mörk AC, Ståhl E. Measurement properties and interpretation of three shortened versions of the asthma control questionnaire. <em>Respir Med</em>. 2005;99(5):553-558. <a href="https://www.sciencedirect.com/science/article/pii/S0954611104003920" target="_blank">doi:10.1016/j.rmed.2004.10.008</a></strong></p>
						<ul>
							<li>The aims of this analysis were: (1) to examine the measurement properties of three shortened versions of the ACQ (symptoms alone, symptoms plus FEV1 and symptoms plus short-acting beta2-agonist), and (2) to determine whether using the shortened versions would alter the results of a clinical trial.</li>
							<li>The analysis showed that the measurement properties of all four versions of the ACQ are very similar. Clinical trial results using the four versions were almost identical. For interpretability, the minimal important difference for all four versions was close to 0.5. The authors concluded that the three shortened versions of the ACQ can be used in large clinical trials without loss of validity or change in interpretation.</li>
						</ul>
					`,
				},
        {
          title: "Calculation<span class='show--md'> & interpretation</span>",
          display: false,
          accordion: false,
					content: `
						<h4 class="txt--lg">Calculation</h4>
						<p>To calculate the total ACQ score, a score of 0-6 is  assigned to values for each criterion as indicated in the table below. The total ACQ  score is the mean value calculated after adding the individual scores for each criterion. </p>
						<table class="tbl table">
							<tr>
								<th>Name</th>
								<th width="120">Input value</th>
								<th width="80" align="right">Score</th>
							</tr>
							<tr>
								<td valign="top">
										1. On average, during the past week, how often were you woken by your asthma during the night? 
								</td>
								<td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>Never</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td>Hardly ever</td>
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>A few times</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>Several times</td>
                      <td>3</td>
                    </tr>
                    <tr>
                      <td>Many times</td>
                      <td>4</td>
                    </tr>
                    <tr>
                      <td>A great many times</td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>Unable to sleep because of asthma</td>
                      <td>6</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td valign="top">
										2. On average, during the past week, how bad were your asthma symptoms when you woke up in the morning? 
								</td>
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No symptoms</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td>Very mild symptoms</td>
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>Mild symptoms</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>Moderate symptoms</td>
                      <td>3</td>
                    </tr>
                    <tr>
                      <td>Quite severe symptoms</td>
                      <td>4</td>
                    </tr>
                    <tr>
                      <td>Severe symptoms</td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>Very severe symptoms</td>
                      <td>6</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td valign="top">
										3. In general, during the past week, how limited were you in your activities because of your asthma? 
								</td>                
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>Not limited at all</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td>Very slightly limited</td>
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>Slightly limited</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>Moderately limited</td>
                      <td>3</td>
                    </tr>
                    <tr>
                      <td>Very limited</td>
                      <td>4</td>
                    </tr>
                    <tr>
                      <td>Extremely limited</td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>Totally limited</td>
                      <td>6</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td valign="top">
										4. In general, during the past week, how much shortness of breath did you experience because of your asthma? 
								</td>
                             
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>None</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td>A very little</td>
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>A little</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>A moderate amount</td>
                      <td>3</td>
                    </tr>
                    <tr>
                      <td>Quite a lot</td>
                      <td>4</td>
                    </tr>
                    <tr>
                      <td>A great deal</td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>A very great deal</td>
                      <td>6</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td valign="top">
										5. In general, during the past week, how much of the time did you wheeze? 
								</td>
                  
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>Not at all</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td>Hardly any of the time</td>
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>A little of the time</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>A moderate amount of the time</td>
                      <td>3</td>
                    </tr>
                    <tr>
                      <td>A lot of the time</td>
                      <td>4</td>
                    </tr>
                    <tr>
                      <td>Most of the time</td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>All the time</td>
                      <td>6</td>
                    </tr>
                  </table>
								</td>
							</tr>
						</table>
						<h4 class="txt--lg">Interpretation of ACQ 5 scores</h4>
						<p>In general, patients with a score below 1.0 are likely to have adequately controlled asthma, and above 1.0 their asthma is not likely to be well-controlled. However, there is a very grey area between 0.75 and 1.25 where patients are on the borderline of adequate control. A change or difference in score of 0.5 is the smallest that can be considered clinically important. This means that changes of 0.5 or greater would justify a change in the patient’s treatment in the absence of undue side effects.</p>
						<p>In summary:</p>
						<ul>
							<li>A total ACQ score of below 0.75 is considered to be adequately controlled. </li>
							<li>An ACQ score of between 0.75 and 1.25 is considered to be on the borderline of adequate control </li>
							<li>An ACQ score of over 1.25 is considered to be not well controlled. </li>
							<li>A change or difference in score of 0.5 or greater should prompt change in treatment although this may differ among individual patients.</li>
              <li>Note that clinicians should also refer to local guidance where appropriate.</li>
						</ul>
					`,
				},
        {
          title: "Practice<span class='show--md'> considerations</span>",
          display: false,
          accordion: false,
					content: `
						<p>In using the ACQ 5 in practice, clinicians should be aware that: </p>
						<p>The shortened versions of the original 7-question ACQ, including the ACQ 5, have been validated and have shown good measurement properties but not quite so good as those of the complete ACQ version (<a href="https://pubmed.ncbi.nlm.nih.gov/15823451/" target="_blank">Juniper et al, 2005</a>). It is better to use a shortened version than no version at all.  </p>
						<p>The ACQ is not designed to differentiate between daytime and night-time asthma control. </p>
						<p>The ACQ is well validated in adults and for all children 6-17 years. The self-administered version can be used by children 11 years and older. For children of 6-10 years, the questionnaire should be administered by a trained interviewer. The ACQ has not been validated for children younger than 6 years old. </p>
					`,
				}
      ]    
    };
  },
    
	methods: {		
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) 
        {
          window.open(url,target);  
        }
        else{
          if(target == "_blank") {
            let data = {title:'',nodeid: dataId, href:url, target: target};
            window.Native('dataCallback', data);
          } 
        }	
      }
    },
		selectTab(selectedTab) {
			this.tabs.forEach(tab => {
				if(tab.display) {
					tab.display = false;
				} else {
					tab.display = (tab.title == selectedTab.title);
				}
			});
		},
    reset() {
      this.emailaddresses = "";
      this.patientname = "";
      this.patientchinumber = "";
      this.result.score = 0;
      this.result.calctext = "";
      this.result.text = "";
      this.displayresult= false;
      this.showform = false;
      this.errormessage= "";
      this.emailmessage = "";
      this.isvalid= false;
      this.answered_count= 0;
			this.answer_acutechange= false;
			this.current_page = 1;
			this.current_q_index = 0;
      this.questions.forEach(q => {
        q.options.forEach(o => {
            o.selected = false;
          });
      });
      this.current_question = null;
    },
		displayForm(){		
      this.showform = !this.showform;
		},
    copyToClipboard() {
      var range;
      var finalText = "";
      if (document.selection) { // IE
        range = document.body.createTextRange();
        range.moveToElementText(document.getElementById('calculator-copy'));
        range.select();
        finalText = this.getDateToday() + "\n\nAsthma Control Questionnaire (ACQ5)\n\n" + range + "\nEnter action taken as a result of this alert";
        document.selection.empty();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(document.getElementById('calculator-copy'));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        finalText = this.getDateToday() + "\n\nAsthma Control Questionnaire (ACQ5)\n\n" + window.getSelection().toString() + "Enter action taken as a result of this alert";
        window.getSelection().removeAllRanges();
      }
      var dummy = document.createElement("textarea");
      // Add it to the document
      document.body.appendChild(dummy);

      // Set its ID
      dummy.setAttribute("id", "dummy_id");

      // Output the array into it
      document.getElementById("dummy_id").value = finalText;

      // Select it
      dummy.select();

      // Copy its contents
      document.execCommand("copy");

      // Remove it as its not needed anymore
      document.body.removeChild(dummy);

      var clicked = false;
      var copyButton = document.getElementById('copyButton');
      if (!clicked) {
            var last = copyButton.innerHTML;
            copyButton.innerHTML = 'Copied!';
            clicked = true;
            setTimeout(function () {
                copyButton.innerHTML = last;
                clicked = false;
            }.bind(copyButton), 5000);
        }
    },
    getDateToday() {
      var date = "";
      var today = new Date();
      date = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + " " + (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) + ":" + (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());
      return date;
    },
    sendToPDF() {
			// if (this.emailaddresses == "") {
			//     this.emailmessage = "You must supply at least one email address.";
			// }
			// else if (this.patientname == "") {
			//     this.emailmessage = "You must supply the patient's name.";
			// }
			// else if (this.patientchinumber == "") {
			//     this.emailmessage = "You must supply the patient CHI number."
			// }
			console.log("Test")

			if (this.patientchinumber == "" || this.patientname == "" || this.patientchinumber == ""){
					this.emailmessage = "All fields are required."
			}
			else {
				var formToPost = {
						EmailAddresses: this.emailaddresses,
						PatientName: this.patientname,
						PatientChiNumber: this.patientchinumber,
						Questions: this.questions,
						Result: this.result,
						DisplayWarning: this.answered_count < this.questions.length,
				};

				var model = JSON.stringify(formToPost);

				fetch("/Asthma/GetACQ5PDF", {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: model
				})
				.then(response => response.text())
				.then(data => {
						if (data.startsWith("Email Error: ")) {
								this.emailmessage = data.replace("Email Error: ", "");
								this.showform = true;
						} else {
								this.emailmessage = data;
								this.showform = false;
						}
				})
				.catch((error) => {
						console.log('EMAIL ERROR', error);
				});
			}
    },
    calculateclicked() {
			window.scrollTo(0, 0);
      this.emailaddresses = "";
      this.patientname = "";
      this.patientchinumber = "";	
      this.emailmessage = "";	
			this.isvalid =  this.current_q_index == this.answered_count;
      if (this.isvalid) {
        this.displayresult = true;
        this.errormessage = "";
      }
      if (!this.isvalid) {
				this.errormessage = "Please select a value, this is a required field.";
				setTimeout(()=> {
					document.getElementById("error").scrollIntoView(true)},100);
      }
		},
		pageBack() {
			window.scrollTo(0, 0);		
			this.errormessage = "";
      this.current_page--;
			this.current_q_index--; 
			if (this.current_page >2) {
        this.current_question = this.questions[this.current_page-3];
      } 
			if (this.current_page < 2) {	
				this.current_q_index = 0; 
			}			
    },
    pageForward() {			
			window.scrollTo(0, 0);			
			this.current_page++;
      if (this.current_page > 2) {
				if(this.current_q_index <= this.answered_count) {
					this.errormessage = "";
					this.current_q_index++; 
					this.current_question = this.questions[this.current_page-3];
				} else {
					this.current_page--;
					this.current_question = this.questions[this.current_page-3];
					this.errormessage = "Please select a value, this is a required field.";
				}
			}
    },
    closedclicked() {
      this.displayresult = false;
    },
    optionclicked(qid, oid) {
      this.displayresult = false;
      let _score = 0;
      this.questions.forEach(q => {
        if (q.id === qid) {
          q.options.forEach(o => {
            if (o.id === oid) {
              if(o.selected)
              {
                o.selected = false;
              }
              else
              {
                o.selected = true;
              }
              
            } else {
              o.selected = false;
            }
          });
        }
      });
      let _cnt = 0;
      this.questions.forEach(q => {
        if (q.required) {
         // _required_cnt++;
        }
      });
      this.questions.forEach(q => {
        q.options.forEach(o => {
          if (o.selected) {
            _score += o.value;
            _cnt++;
          }
        });
      });

      this.answered_count = _cnt;
      this.result.score = _score / this.answered_count;

      if (this.result.score <= 0.75) {
				this.result.text = "Adequate control. Refer to guidance.";
				this.result.subtext = "For an ACQ score of below 0.75, asthma is considered to be adequately controlled.<br><br>Note that a change or difference in score of 0.5 or greater should prompt change in treatment although this may differ among individual patients.<br><br>Clinicians should also refer to local guidance where appropriate. "
      }
      if (this.result.score > 0.75 && this.result.score <= 1.25) {
				this.result.text = "Borderline. Refer to guidance.";	
				this.result.subtext = "An ACQ score of between 0.75 and 1.25 is considered to be on the borderline of adequate control.<br><br>Note that a change or difference in score of 0.5 or greater should prompt change in treatment although this may differ among individual patients.<br><br>Clinicians should also refer to local guidance where appropriate. "
      }
      if (this.result.score > 1.25) {
				this.result.text = "Not well controlled. Refer to guidance.";
				this.result.subtext = "An ACQ score of above 1.25 is considered to be not well controlled. <br><br>Note that a change or difference in score of 0.5 or greater should prompt change in treatment although this may differ among individual patients.<br><br>Clinicians should also refer to local guidance where appropriate. "
      }

      

      let _calctext = "";
      let _idx2 = 0;
      //let _len = this.questions.length;
      this.questions.forEach(q => {
        //_calctext = _calctext + q.title+": ";

        q.options.forEach(o => {
          if (o.selected) {
            if (_idx2 === 0) {
							_calctext = _calctext + "<strong>" + q.title + "</strong><br><span class='badge badge-success badge-pill'>"+ o.value_label + "</span>&nbsp;"+ o.text +"<br><br>";
            } else {
							_calctext = _calctext + "<strong>" + q.title + "</strong><br><span class='badge badge-success badge-pill'>"+ o.value_label + "</span>&nbsp;"+ o.text +"<br><br>";
            } 
          }
				});

        _idx2++;
      });
      
      this.result.calctext = _calctext;
    }
  }
};
</script>
